module.exports = __webpack_public_path__ + "img/2.8d528792.jpg";